export default __webpack_public_path__ + "static/media/RoboticArmImage@3x.3844c52d.png";